import { useEffect, useState } from "react";
import NewEditRecipeForm, { IRecipeNewEdit } from "../../components/feature/NewEditRecipeForm/NewEditRecipeFrom";
import setThemeColor from "../../utils/setThemeColor/setThemeColor";
import { useParams } from "react-router-dom";
import { Api } from "../../services/Api";
import { NavMenu } from "../../components/feature/NavMenu/NavMenu";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { IOptions } from "../../components/feature/NavMenu/elements/AdditionalOptionsMenu/AdditionalOptionsMenu";
import Authorize from "../../components/common/Authorize/Authorize";
import styles from "./EditRecipePage.module.css";
import { useTranslation } from "react-i18next";
import setWebPageTitle from "../../utils/setWebPageTitle/setWebPageTitle";
import setWebPagePreviewImage from "../../utils/setWebPagePreviewImage/setWebPagePreviewImage";

const EditRecipePage: React.FC = () => {
    const { t } = useTranslation();
    const [recipe, setRecipe] = useState<IRecipeNewEdit | null>(null);
    const isLoggedIn = useSelector((state: RootState) => state.client.isLoggedIn);
    const [options, setOptions] = useState<IOptions[]>([]);
    const isMobile: boolean = useSelector((state: RootState) => state.client.isMobile);

    const id = useParams().id;
    const url = "getrecipe/" + id;

    useEffect(() => {
        if (isLoggedIn) {
            setOptions([
                {
                    link: "/",
                    name: t("containers.myRecipesPage.title"),
                    icon: <i className="bi bi-collection"></i>,
                },
                {
                    link: "/explore",
                    name: t("containers.explorePage.title"),
                    icon: <i className="bi bi-globe-americas"></i>,
                },
                {
                    link: "/info",
                    name: t("containers.infoPage.title"),
                    icon: <i className="bi bi-info-circle"></i>,
                },
            ]);
        } else {
            setOptions([
                {
                    link: "/explore",
                    name: t("containers.explorePage.title"),
                    icon: <i className="bi bi-globe-americas"></i>,
                },
                {
                    link: "/info",
                    name: t("containers.infoPage.title"),
                    icon: <i className="bi bi-info-circle"></i>,
                },
            ]);
        }
    }, [isLoggedIn]);

    useEffect(() => {
        setThemeColor("#ffffff");
        setWebPagePreviewImage();
        setWebPageTitle();
        Api.get(url)
            .then((res) => res.data)
            .then(
                (result) => {
                    setRecipe(result);
                },
                (error) => {
                    console.log(error);
                },
            );
    }, []);

    return (
        <div>
            <NavMenu
                options={options}
                title={
                    <span>
                        <i className="bi bi-pencil-square"></i> {t("containers.editRecipePage.title")}
                    </span>
                }
            />
            {isMobile && (
                <p className={styles.title}>
                    <span>
                        <i className="bi bi-pencil-square"></i> {t("containers.editRecipePage.title")}
                    </span>
                </p>
            )}
            <Authorize
                strict={true}
                userId={recipe?.userId}
                code={<NewEditRecipeForm recipe={recipe} isEditMode={true} />}
            />
        </div>
    );
};

export default EditRecipePage;
